import useScreenSize from '@/hooks/useScreenSize';

import { ErrorBoundary } from '@/components/common/CatchErrorComponent';
import {
  PageBlockStyles,
  type PageSnsBlock,
} from '@/components/common/Providers/GraphqlProvider/generated';
import { Typography } from '@/components/ui/Typography';

import NewsSocialMedia from '../../PageNewsletterBlock/public2/components/NewsSocialMedia';
import { PressroomBlockStyle } from './PressRoomSocialNetworks';

interface IPressRoomSocialNetworksWithoutContextProps {
  snsBlock?: PageSnsBlock;
  showSnsBlock?: boolean;
}

const PressRoomSocialNetworksWithoutContext = ({
  showSnsBlock,
  snsBlock,
}: IPressRoomSocialNetworksWithoutContextProps) => {
  const { isScreenLargerThan } = useScreenSize();

  const pressroomBlockStyle: PressroomBlockStyle = {
    header: {
      isA: false,
      isB: false,
      isC: false,
    },
    news: {
      isA: false,
      isB: false,
      isC: false,
    },
    tags: {
      isA: false,
      isB: false,
      isC: false,
    },
    sns: {
      isA: !snsBlock || !snsBlock.pageBlockStyle || snsBlock.pageBlockStyle === PageBlockStyles.A,
      isB: snsBlock?.pageBlockStyle === PageBlockStyles.B,
      isC: snsBlock?.pageBlockStyle === PageBlockStyles.C,
    },
  };

  if (!snsBlock?.items || (isScreenLargerThan && !showSnsBlock)) return null;

  return (
    <ErrorBoundary fallback={'Oops, hubo un error'}>
      <div className="mb-[100px] flex flex-col gap-[30px]">
        <Typography variant={'h3'} className="text-[32px]">
          Nuestras redes
        </Typography>
        <NewsSocialMedia
          items={snsBlock.items.map((e) => ({
            id: e.id,
            link: e.itemLink?.url,
            snsSocialNetworkType: e.snsSocialNetworkType,
          }))}
          blockStyle={pressroomBlockStyle.sns}
        />
      </div>
    </ErrorBoundary>
  );
};

export default PressRoomSocialNetworksWithoutContext;

export function PressRoomSocialNetworksWithoutContextSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="mb-2 h-4 w-48 rounded bg-gray-200" />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <div className="h-36 w-full rounded bg-gray-200" />
        <div className="h-36 w-full rounded bg-gray-200" />
        <div className="h-36 w-full rounded bg-gray-200" />
      </div>
    </div>
  );
}
